import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StaffFilter } from '@/api/DTO/staff/staffList.interface';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import { UserRole } from '@/api/enum/userRole.enum';

export default function StaffListSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<StaffFilter>();

	const staffList = [
		{ name: t('common.admin'), id: UserRole.ROLE_WEB_ADMIN },
		{ name: t('common.staff'), id: UserRole.ROLE_WEB_STAFF },
	];

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid item xs={2.5}>
				<AppSummarySearchBar
					autoMinWidth={true}
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='roles'
					label={t('staff.staffPermission')}
					options={staffList}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
		</Grid>
	);
}
